'use client'

import * as React from 'react'
import { cn } from '@/lib/utils'

// `.pill-btn` from the prototype theme.css: inline-flex, 6px gap, full radius,
// semibold, springy press (scale 0.97 with the spatial easing on transform).
// We drop the prototype's `background` from the transition: token backgrounds
// are `rgb(var(--token))`, and this Chromium won't interpolate a bg transition
// across a CSS variable, so a state-driven bg swap (e.g. a pill's idle→active
// tint) sticks at the idle color. Letting the background swap instantly is
// correct; transform (press) and box-shadow still animate.
export const pillBtnBase =
  'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full font-semibold ' +
  '[transition:transform_0.15s_cubic-bezier(0.3,1.3,0.4,1),box-shadow_0.15s] ' +
  'active:scale-[0.97]'

export interface PillButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'outline' | 'primary' | 'container' | 'ghost'
}

export const PillButton = React.forwardRef<HTMLButtonElement, PillButtonProps>(
  ({ className, variant = 'outline', type = 'button', ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      className={cn(
        pillBtnBase,
        'px-[14px] py-2 text-[13px]',
        {
          'border border-outline bg-surface text-ink': variant === 'outline',
          'bg-primary text-white shadow-e1': variant === 'primary',
          'bg-primary-container text-on-primary-container': variant === 'container',
          'bg-transparent text-ink-secondary': variant === 'ghost',
        },
        className
      )}
      {...props}
    />
  )
)
PillButton.displayName = 'PillButton'
